/**
 * @prettier
 */

// React Packages
import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

// Components
import CustomButton from "../../components/CustomButton";

// Images
import successSvg from "../../assets/img/success.svg";

// Config
import { ACTION_LABELS } from "../../config/dataDogActionLabels";
const ACTION = ACTION_LABELS.messages;

class StageComplete extends Component {
    constructor(props) {
        super(props);
        this.primaryFocusRef = React.createRef();
    }

    componentDidMount() {
        // Sets focus to primary heading on first render
        if (this.primaryFocusRef && this.primaryFocusRef.current) {
            this.primaryFocusRef.current.focus();
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="stage-complete">
                <div className="stage-complete-content">
                    <h1 className="" ref={this.primaryFocusRef} tabIndex={0}>
                        {t(this.props.message)}
                    </h1>

                    <div className="success-logo">
                        <img alt="success tick" src={successSvg} />
                    </div>

                    {!this.props.hideContinue && (
                        <p>{t("idpal_please_continue")}</p>
                    )}
                </div>

                {!this.props.hideButton && (
                    <div id="continue" className="button-container">
                        <CustomButton
                            className={"btn"}
                            label={t("idpal_continue")}
                            handleClick={() => this.props.continue()}
                            actionDataLabel={ACTION.stageCompleteButton}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default withTranslation("translation")(connect()(StageComplete));
